import image from '../../../../static/working@large.jpg';

const key = 'working-at-kingston';

export default {
  rootNavKey: [key],
  parentKeys: [key],
  image,
};
